"use client"
import { decodeContent } from "@/utils";
import { PageData } from "./DynamicPageContent";

const Page2 = ({ pageData, dict, lang }: { pageData: PageData, dict: any, lang: string }) => {
    const getSpecValue = (key: string, defaultValue: any = null) => {
        if (!pageData?.specifications) return defaultValue;
        const spec = pageData.specifications.find((s: any) => s.key === key);
        return spec?.value || defaultValue;
    };
    const caregivingResources = getSpecValue('resources', []);
    const title = getSpecValue('title', '');
    const faqs = getSpecValue('faqs', []);
    const ctaButton = getSpecValue('button', {"button-text": 'Login or Create a New Account', "link": '#'});
    const faqTitle = 'Frequently Asked Questions';
    const bannerImage = getSpecValue('banner', '/images/banner/banner.png');
    const decodedContent = decodeContent(pageData.content || '', true);

    
    

    return <>
        <section className="text-hero-banner ">
            <div className="container">
                <div className="row">
                    <div className="col-12 text-center">
                        <h1>{pageData?.title}</h1>
                    </div>
                </div>
            </div>
        </section>
        <section className="help-sec">
            <div className="container">
                <div className="row">
                    <div className="col-lg-6">
                        <div className="care-img py-lg-4">
                            <img src={bannerImage} alt="" />
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="help-content care">
                           <div dangerouslySetInnerHTML={{ __html: decodedContent }} />
                           <a href={ctaButton?.find((item: any)=>item.key== "link")?.value} className="btn btn-primary">{ctaButton?.find((item: any)=>item.key== "button-text")?.value}</a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        {caregivingResources && caregivingResources.length > 0 && (
            <section className="resource-sec">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="resource-heading">
                                <h2>{title} Resources</h2>
                            </div>
                        </div>
                        {caregivingResources.map((resource: any, index: number) => (
                            <div key={index} className="col-lg-3 col-md-6 col-sm-6 col-6">
                                <div className="resource-card">
                                    <div className="card-img">
                                        <img src={resource.image || '/images/icons/card_1.png'} alt={resource.title} />
                                    </div>
                                    <div className="card-conttent">
                                        <h4>
                                            <a href={resource.link || '#'}>{resource.title}</a>
                                        </h4>
                                        <p>{resource.description}</p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        )}

        {faqs && faqs.length > 0 && (
        <section className="faq-sec">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="faq-heading">
                  <h2>{faqTitle}</h2>
                </div>
                <div className="accordion" id="care-accordion">
                  {faqs.map((faq: any, index: number) => {
                    const accordionId = `heading${index}`;
                    const collapseId = `collapse${index}`;
                    
                    return (
                      <div key={index} className="accordion-item">
                        <h2 className="accordion-header" id={accordionId}>
                          <button
                            className="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target={`#${collapseId}`}
                            aria-expanded="false"
                            aria-controls={collapseId}
                          >
                            {faq.question || faq.title}
                          </button>
                        </h2>
                        <div
                          id={collapseId}
                          className="accordion-collapse collapse"
                          aria-labelledby={accordionId}
                          data-bs-parent="#care-accordion"
                        >
                          <div className="accordion-body">
                            <div className="service-details">
                              {faq.answer || faq.content}
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </section>
      )}
    </>
}

export default Page2;